import React from 'react';
import { MODULES } from '../../../common/constants';
import PageHeader from '../../../components/PageHeader';
import CommonImageForm from './CommonImageForm';

const AddEditImage = () => {
  return (
    <>
      <PageHeader menu={MODULES?.ASSETS} />
      <div className="page-wrapper">
        <div className="page-wrapper-body">
          <CommonImageForm />
        </div>
      </div>
    </>
  );
};

export default AddEditImage;
